<template>
    <CRow>
        <CCol>
            <CCard class="mb-4">
                <CCardHeader>
                    <strong>Стол заказов</strong>
                    <ShopCatalogTabLinks class="mt-2" />
                </CCardHeader>
                <CCardBody>
                    <p class="text-muted">
                        Сообщения, которые гости отправили с экрана обратной связи.
                    </p>

                    <div
                        v-if="loading"
                        class="text-muted"
                    >
                        Загрузка…
                    </div>
                    <div
                        v-else-if="!items.length"
                        class="text-muted"
                    >
                        Обращений пока нет.
                    </div>
                    <div
                        v-else
                        class="table-responsive"
                    >
                        <table class="table table-striped mb-0">
                            <thead>
                                <tr>
                                    <th>Дата</th>
                                    <th>Страница</th>
                                    <th>Сообщение</th>
                                    <th>MAX</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in items"
                                    :key="item.id"
                                >
                                    <td class="text-nowrap">{{ formatDate(item.created_at) }}</td>
                                    <td class="text-nowrap">{{ item.page || '—' }}</td>
                                    <td class="shop-feedback__message">{{ item.message }}</td>
                                    <td>
                                        <span :class="statusClass(item.max_status)">
                                            {{ statusLabel(item.max_status) }}
                                        </span>
                                        <div
                                            v-if="item.max_status === 'failed' && item.max_error"
                                            class="small text-muted mt-1"
                                        >
                                            {{ item.max_error }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div
                        v-if="pages > 1"
                        class="d-flex align-items-center mt-3"
                    >
                        <CButton
                            size="sm"
                            color="secondary"
                            :disabled="page <= 1 || loading"
                            @click="load(page - 1)"
                        >
                            Назад
                        </CButton>
                        <span class="mx-3">{{ page }} / {{ pages }}</span>
                        <CButton
                            size="sm"
                            color="secondary"
                            :disabled="page >= pages || loading"
                            @click="load(page + 1)"
                        >
                            Дальше
                        </CButton>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from 'vue';
import ShopCatalogTabLinks from '@/components/ShopCatalogTabLinks';

export default {
    name: 'ShopFeedback',

    components: {
        ShopCatalogTabLinks
    },

    data() {
        return {
            loading: false,
            items: [],
            total: 0,
            page: 1,
            limit: 50
        };
    },

    computed: {
        pages() {
            return Math.max(1, Math.ceil(this.total / this.limit));
        }
    },

    mounted() {
        this.load(1);
    },

    methods: {
        formatDate(value) {
            if (!value) return '—';
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return value;
            return date.toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' });
        },

        statusLabel(status) {
            if (status === 'sent') return 'Отправлено';
            if (status === 'failed') return 'Не отправлено';
            return 'Отправляется';
        },

        statusClass(status) {
            if (status === 'sent') return 'text-success';
            if (status === 'failed') return 'text-danger';
            return 'text-muted';
        },

        load(page) {
            this.loading = true;
            return Vue.axios.get('/shop-feedback', {
                params: { page, limit: this.limit }
            })
                .then(({ data }) => {
                    this.items = data.items || [];
                    this.total = data.total || 0;
                    this.page = data.page || page;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить обращения');
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style scoped>
.shop-feedback__message {
    white-space: pre-wrap;
    min-width: 16rem;
}
</style>
